import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { ReactComponent as CloseIcon } from "../../../../../../../assets/img/svg/CloseIcon.svg";
import { ReactComponent as Document } from "../../../../../../../assets/img/svg/DocumentLight.svg";
// import { ReactComponent as File } from "../../../../../../../assets/img/DocumentLarge.jpg"
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { getUniqueKey } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
  successToast,
} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { putpost, uploadpost } from "services/utils";
import { endpoint } from "views/pages/manage/common/constant";
import ALoader from "views/pages/manage/common/a-loader";
import { Row, Col } from "reactstrap";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { ReactComponent as ExcellFile } from "../../../../../../../assets/img/svg/excel.svg";

const DocUploadModal = ({
  open,
  setOpen,
  saveHandler,
  values,
  acceptedFileTypes = [],
  maxUploadFileSize, // in Mb
  serviceName,
  uniqueKeyParameter,
  uploadedFileS3Key,
  uploadedFileName,
  modalTitle,
  viewMode = false,
  viewUploadedImage = false,
  propStyle = {},
  isBulkCollection = false,
  customComponent,
  paymentMode,
  fileTypeErrorMsg = "File type not supported!!",
  fileSizeErrorMsg = `The file size exceeds the limit of ${maxUploadFileSize} MB. Please reduce the size of the file to upload successfully`,
  modalProps = {}
}) => {
  const maxFileSize = maxUploadFileSize * 1048576; // converting to bits
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [fileData, setFileData] = useState({s3Key:values?.gstDetails?.gstDocumentS3Key, fileName:values?.gstDetails?.gstCertificateName})
  const [fileData, setFileData] = useState({
    s3Key: uploadedFileS3Key,
    fileName: uploadedFileName,
  });
  const [fileUrl, setFileUrl] = useState("");

  const dataToServer = {
    bulk: false,
    fileName: null,
    docType: "pdf",
    keyValue: `${uniqueKeyParameter}_${getUniqueKey()}`,
    serviceName: serviceName,
  };

  const headerStyles = {
    fontSize: "16px",
    fontWeight: 600,
    color: "#0F0F0F",
  };

  const infoStyles = {
    fontSize: "14px",
    fontWeight: 400,
    color: "#545454",
  };

  const uploadLabelStyles = {
    ...headerStyles,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    letterSpacing: "1px",
    outline: "none",
    border: "none",
    padding: "10px 16px",
    backgroundColor: "#00B0F5",
    color: "#FFFFFF",
    width: "100%",
    borderRadius: "8px",
    cursor: "pointer",
  };

  const updateLabelStles = {
    ...uploadLabelStyles,
    color: "#00B0F5",
    border: "2px solid #00B0F5",
    backgroundColor: "#FFFFFF",
    padding: "8px",
  };

  function isValidFileName(fileName) {
    const nameArr = fileName?.split(".");
    nameArr.pop();
    const baseName = nameArr.join(".");
    console.log('baseName', baseName);
    return /^[a-zA-Z0-9 !\-_.\*'()]+$/.test(baseName);
  }

  const showFile = (dataFile, targetFile) => {
    console.log("targetFile", targetFile);
    try {
      const fileSelected = dataFile || targetFile;

      if(!isValidFileName(fileSelected?.name)){
        failureToast("File name contains invalid characters!");
        return;
      }

      const fileType = fileSelected?.name?.split(".")?.pop()?.toLowerCase();
      if (!acceptedFileTypes?.includes(`.${fileType}`)) {
        failureToast(fileTypeErrorMsg);
        return;
      }
      if (fileSelected.size > maxFileSize) {
        failureToast(fileSizeErrorMsg);
        return;
      }
      setFile(fileSelected);
      setLoading(true);
      getFilePath(fileSelected.name, fileSelected);
    } catch (e) {
      console.log("Error", e);
      setLoading(false);
    }
  };

  const getFilePath = (name, file) => {
    try {
      setLoading(true);
      const formData = {
        ...dataToServer,
        fileName: name,
        docType: name?.split(".")?.pop()?.toLowerCase(),
      };

      putpost(
        endpoint.fetchS3Url.getUrl,
        (data) => {
          if (data?.code === 200 && data.data) {
            saveDataToStorage(data.data, file);
          }
        },
        (data) => {
          failureToast(data["message"]);
          setLoading(false);
          setFile(null);
        },
        formData,
        "post"
      );
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const saveDataToStorage = (res, file) => {
    try {
      const formData = new FormData();

      formData.append("File", file);
      uploadpost(
        res.storage,
        (data) => {
          setFileData({
            ...fileData,
            s3Key: res.key,
            fileName: file.name,
            processId: res.processId,
          });
          successToast("File uploaded successfully");
          setLoading(false);
        },
        (data) => {
          failureToast("File upload failed, please try again after sometime.");
          setLoading(false);
        },
        file,
        file?.type,
        file?.name
      );
    } catch (e) {
      failureToast("Unable to upload file, please try after sometime.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (viewUploadedImage && fileData?.s3Key) {
      downLoadFile(false, setFileUrl);
    }
  }, [fileData]);

  const downLoadFile = async (download = true, setFileUrl) => {
    const templateUrl = await fetchAllPostPromisedData(
      `${endpoint.fetchS3Url.getDownloadUrl}?key=${fileData?.s3Key}`,
      {}
    );
    if (templateUrl?.code === 200 && templateUrl?.data) {
      if (!download) {
        setFileUrl(templateUrl?.data?.url);
      } else {
        window.open(`${templateUrl?.data?.url}`);
      }
    } else {
      failureToast("Something went wrong please try after sometime.");
    }
  };

  const FileInput = ({ action, styles }) => {
    return (
      <>
        <label htmlFor="gstFileInput" style={styles}>
          {action}
        </label>
        <input
          onChange={(e) => showFile(null, e.target.files[0])}
          type="file"
          hidden
          id="gstFileInput"
          accept={acceptedFileTypes.join(",")}
          disabled={isBulkCollection && !paymentMode}
        />
      </>
    );
  };

  const DisplayImportInput = () => {
    return (
      <>
        <div className="d-flex flex-column align-items-center justify-content-center my-4">
          <Document />
          <span
            className="mt-2"
            style={{ ...infoStyles, color: "#333" }}
          >{`File supported: ${acceptedFileTypes.join(", ")}`}</span>
        </div>
        <FileInput
          action={"Upload"}
          styles={
            isBulkCollection
              ? paymentMode
                ? uploadLabelStyles
                : {
                    ...updateLabelStles,
                    backgroundColor: "#a1aeb7",
                    border: "1px solid #a1aeb7",
                    // outline: 'none !important',
                    cursor: "not-allowed",
                    color: "#ffffff",
                  }
              : uploadLabelStyles
          }
        />
      </>
    );
  };

  const DisplayFile = ({ fileName, setFile, onDownload }) => {
    return (
      <>
        <div className="d-flex flex-column justify-content-center align-items-center my-4">
          {viewUploadedImage ? (
            <img src={fileUrl} style={{ height: "225px", width: "225px" }} />
          ) : isBulkCollection ? (
            <ExcellFile style={{ width: "56px", height: "53px" }} />
          ) : (
            <img
              src={require("../../../../../../../assets/img/DocumentLarge.jpg")}
            />
          )}
          <span className="mt-2" style={{ ...infoStyles, ...propStyle }}>
            {fileName}
          </span>
        </div>

        {!viewMode && (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <AButton
              className="ml-0"
              children={"Save"}
              variant="primary_filled"
              onClick={() => {
                saveHandler(fileData.s3Key, fileData?.fileName, fileData,setFile,setFileData);
              }}
              updatedStyle={{ width: "100%", marginBottom: "6px" }}
            />

            <div className="d-flex justify-content-between w-100">
              <FileInput action={"Update"} styles={updateLabelStles} />

              <AButton
                children={"Download"}
                variant="outline"
                onClick={onDownload}
                updatedStyle={{ width: "100%" }}
              />
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <Modal size="sm" isOpen={open} {...modalProps}>
      <ModalBody>
        <div className="d-flex justify-content-between mb-1">
          <div style={headerStyles}>{modalTitle}</div>
          <CloseIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              setFile(null);
              setOpen(false);
            }}
          />
        </div>
        {isBulkCollection && customComponent}
        <div style={infoStyles}>{`Max file size ${maxUploadFileSize} MB`}</div>
        {console.log('file',file,fileData)}
        {loading ? (
          <div style={{ height: "100px" }}>
            <ALoader />
          </div>
        ) : !(file || fileData?.s3Key) ? (
          <DisplayImportInput showFile={showFile} />
        ) : (
          <DisplayFile
            onDownload={downLoadFile}
            fileName={file?.name || fileData?.fileName}
            setFile={setFile}
          />
        )}
        <a style={{ display: "none" }} id="link" download></a>
      </ModalBody>
    </Modal>
  );
};

export default DocUploadModal;
